import React, { useState, useEffect } from 'react';
import { Map, CheckCircle2 } from 'lucide-react';
import { MAPBOX_STYLES, getSavedMapboxStyle, setSavedMapboxStyle } from '../utils/mapTiles';

export default function MapboxStyleSelector() {
  const [currentStyle, setCurrentStyle] = useState(getSavedMapboxStyle);
  const [savedFeedback, setSavedFeedback] = useState(false);

  useEffect(() => {
    const handleStyleChange = (e) => {
      if (e.detail?.style) {
        setCurrentStyle(e.detail.style);
      }
    };
    window.addEventListener('loops_map_style_changed', handleStyleChange);
    return () => window.removeEventListener('loops_map_style_changed', handleStyleChange);
  }, []);

  const handleSelect = (styleId) => {
    setSavedMapboxStyle(styleId);
    setCurrentStyle(styleId);
    setSavedFeedback(true);
    setTimeout(() => setSavedFeedback(false), 2500);
  };

  const activeStyleObj = MAPBOX_STYLES.find(s => s.id === currentStyle) || MAPBOX_STYLES[0];

  return (
    <div className="overlay-card" style={{ padding: '16px 20px', marginBottom: '16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Map size={18} color="#38bdf8" />
          <div>
            <h3 style={{ fontSize: '0.95rem', fontWeight: '700', margin: 0, color: '#ffffff' }}>
              Fond de Carte Mapbox
            </h3>
            <span style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
              Style d'affichage Retina des cartes interactives
            </span>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          {savedFeedback && (
            <span style={{ fontSize: '0.75rem', color: '#22c55e', fontWeight: '700', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <CheckCircle2 size={13} />
              Appliqué !
            </span>
          )}

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div
              style={{
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                backgroundColor: activeStyleObj.accentColor || '#38bdf8',
                boxShadow: `0 0 6px ${activeStyleObj.accentColor || '#38bdf8'}`
              }}
            />
            <select
              value={currentStyle}
              onChange={(e) => handleSelect(e.target.value)}
              style={{
                background: '#0f172a',
                color: '#f8fafc',
                border: '1px solid #334155',
                borderRadius: '6px',
                padding: '7px 12px',
                fontSize: '0.82rem',
                fontWeight: '600',
                cursor: 'pointer',
                outline: 'none',
                minWidth: '220px'
              }}
            >
              {MAPBOX_STYLES.map((st) => (
                <option key={st.id} value={st.id}>
                  {st.name} {st.badge ? `(${st.badge})` : ''}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
